import React, { useState, useEffect } from "react";
import { axiosSalary } from "../api/axiosInstance";
import { useAuth } from "../auth/AuthContext";

const AddSessionByManager = ({ open, onClose, rowData, onSuccess }) => {

  const { user } = useAuth();

  const [form, setForm] = useState({
    inTime: "",
    outTime: "",
    reason: ""
  });

  const [sessions, setSessions] = useState([]);

  /* ================= FETCH LAST SESSION ================= */
  useEffect(() => {

    const fetchAttendance = async () => {
      try {

        const res = await axiosSalary.get(
          `/DailyAttendance/GetAttendanceForManagerEdit`,
          {
            params: {
              groupId: user?.groupId,
              restId: rowData?.restId,
              empId: rowData?.empId,
              attendanceDate: new Date(
                rowData.attendanceDate.split("/").reverse().join("-")
              ).toISOString(),
            },
          }
        );

        const data = res.data;
        const allSessions = data?.sessions || [];

        setSessions(allSessions);

        // ✅ IF sessions exist
        if (allSessions.length > 0) {

          const lastSession = allSessions[allSessions.length - 1];

          // 🚨 BLOCK if last session still open
          if (!lastSession.outTimeUtc) {
            alert("Last session is still open. Please close or replace it first.");
            onClose();
            return;
          }

          // ✅ Prefill from last OUT TIME only
          const prefillTime = new Date(lastSession.outTimeUtc)
            .toISOString()
            .slice(0, 16);

          setForm({
            inTime: prefillTime,
            outTime: "",
            reason: ""
          });

        } else {
          // ✅ No sessions → empty form
          setForm({
            inTime: "",
            outTime: "",
            reason: ""
          });
        }

      } catch (err) {
        console.error("Fetch attendance error:", err);

        setForm({
          inTime: "",
          outTime: "",
          reason: ""
        });
      }
    };

    if (open && rowData) {
      fetchAttendance();
    }

  }, [open, rowData, user]);

  /* ================= OVERLAP CHECK ================= */
  const isOverlap = (newIn, newOut) => {
    return sessions.some((s) => {
      const sIn = new Date(s.inTimeUtc);
      const sOut = s.outTimeUtc ? new Date(s.outTimeUtc) : null;

      return newIn < (sOut || newOut) && newOut > sIn;
    });
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async () => {

    if (!form.inTime || !form.outTime) {
      alert("Please enter in/out time");
      return;
    }

    const newIn = new Date(form.inTime);
    const newOut = new Date(form.outTime);

    if (newOut <= newIn) {
      alert("Out Time must be greater than In Time");
      return;
    }

    // 🚨 Overlap validation
    if (isOverlap(newIn, newOut)) {
      alert("Session overlap detected. Please adjust time.");
      return;
    }

    try {

      const payload = {
        groupId: user?.groupId,
        restId: rowData.restId,
        empId: rowData.empId,

        attendanceDate: new Date(
          rowData.attendanceDate.split("/").reverse().join("-")
        ).toISOString(),

        session: {
          sessionId: "", // new session
          inTimeUtc: newIn.toISOString(),
          outTimeUtc: newOut.toISOString(),
        },

        userId: user?.userId,
        reason: form.reason
      };

      await axiosSalary.post(
        "/DailyAttendance/AddSessionByManager",
        payload
      );

      alert("Session added successfully");

      onClose();
      onSuccess && onSuccess();

    } catch (err) {
      console.error("Add session error:", err);
      alert("Failed to add session");
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

      <div className="bg-white rounded-lg p-4 w-[320px]">

        <h3 className="font-semibold mb-3">
          Add Session - {rowData?.empName}
        </h3>

        <div className="space-y-2 text-sm">

          {/* IN TIME */}
          <input
            type="datetime-local"
            value={form.inTime}
            onChange={(e) =>
              setForm({ ...form, inTime: e.target.value })
            }
            className="w-full border p-2 rounded"
          />

          {/* OUT TIME */}
          <input
            type="datetime-local"
            value={form.outTime}
            onChange={(e) =>
              setForm({ ...form, outTime: e.target.value })
            }
            className="w-full border p-2 rounded"
          />

          {/* REASON */}
          <textarea
            placeholder="Reason"
            value={form.reason}
            onChange={(e) =>
              setForm({ ...form, reason: e.target.value })
            }
            className="w-full border p-2 rounded"
          />

        </div>

        <div className="flex justify-end gap-2 mt-3">

          <button
            onClick={onClose}
            className="px-3 py-1 border rounded"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            className="px-3 py-1 bg-blue-600 text-white rounded"
          >
            Save
          </button>

        </div>

      </div>

    </div>
  );
};

export default AddSessionByManager;